import React from 'react';
import { useInput } from '../../../../hooks';
import { emailRegExp, passwordRegExp } from '../../../../utils/utilityEtc';

function IdPwForm({
  formData,
  handleFormData,
  handleOneReset
}) {
  const [isEmailRegx, onChangeEmail] = useInput(true);
  const [isPwdRegx, onChangePwd] = useInput(true);

  const handleEmailCheck = (e) => {
    const value = e.target.value;
    onChangeEmail(emailRegExp(value));
  };

  const handlePasswordCheck = (e) => {
    const value = e.target.value;
    onChangePwd(passwordRegExp(value));
  };

  return (
    <section>
      <h2>가입자 정보 입력</h2>
      <div className="item">
        <div className="input_title">이메일</div>
        <div className="input_cont">
          <div className="input_box white_box">
            <input
              type="text"
              name="email"
              placeholder="이메일 주소 입력"
              value={formData.email}
              onChange={handleFormData}
              onBlur={handleEmailCheck}
            />
            {
              (!isEmailRegx && formData.email) && (
                <div className="r_area">
                  <button
                    type="button"
                    onClick={() => handleOneReset("email")}
                  >
                    <img
                      width="40"
                      src="./static/images/icon/ic_error@2x.png"
                      alt=""
                    />
                  </button>
                </div>
              )
            }
          </div>
          {
            !isEmailRegx && (
              <div className="red_txt fs12_10">
                올바른 이메일 형식이 아닙니다. 예)abc@mathpid.com
              </div>
            )
          }
        </div>
      </div>
      <div className="item">
        <div className="input_title">비밀번호</div>
        <div className="input_cont">
          <div className="input_box white_box">
            <input
              type="password"
              name="password"
              onChange={handleFormData}
              onBlur={handlePasswordCheck}
              placeholder="비밀번호 입력 (영문,숫자,특문 포함 8글자 이상)"
            />
             {
              (passwordRegExp(formData.password)) && (
                <div className="r_area">
                  <button type="button">
                    <img
                      width="40"
                      src="./static/images/icon/ic_check@2x.png"
                      alt=""
                    />
                  </button>
                </div>
              )
            }
          </div>
          <div className="input_box white_box">
            <input
              type="password"
              name="password2"
              onChange={handleFormData}
              placeholder="비밀번호 입력 (영문,숫자,특문 포함 8글자 이상)"
            />
            {
              (passwordRegExp(formData.password2)) && (
                <div className="r_area">
                  <button type="button">
                    <img
                      width="40"
                      src="./static/images/icon/ic_check@2x.png"
                      alt=""
                    />
                  </button>
                </div>
              )
            }
          </div>
          {(() => {
            let msg = ""
            if (!isPwdRegx) {
              msg = "영문, 숫자, 특문 포함 8글자 이상이어야 합니다."
            } else if (
              formData.password &&
              formData.password2 &&
              formData.password !== formData.password2
            ) {
              msg = "입력한 비밀번호와 재입력한 비밀번호가 일치하지 않습니다. 다시 확인해 주세요."
            }

            return (
              <div className="red_txt fs12_10">{msg}</div>
            )
          })()}
        </div>
      </div>
    </section>
  );
}

export default IdPwForm;